import { Add, ArrowBackIos, Group } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from '../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledBackButtonNavigator,
  StyledTitleHeader,
  TooltipStyled
} from '../../../components/layout/main/mainStyles';
import Strings from '../../../i18n';
import { GroupsListTemplate } from '../../../templates/applications/groups/groupsListTemplate';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { ButtonIconStyled } from '../../devices/devicesStyles';
import {
  useAddOddOrEvenGroupMutation,
  useGetGroupsByLocationIdMutation
} from '../../../services/groups/groupsService';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';

export const GroupsView = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [
    getGroups,
    { isSuccess: successGroups, data: dataGroups, isLoading: isLoadingGroups }
  ] = useGetGroupsByLocationIdMutation();
  const [openSideBar, setOpenSideBar] = useState(false);
  const [
    addOddOrEvenGroup,
    {
      isSuccess: isSuccessAddOddOrEvenGroup,
      isLoading: isLoadingAddOddOrEvenGroup
    }
  ] = useAddOddOrEvenGroupMutation();
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.addGroup
  );
  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };
  const handleAddOddOrEvenGroup = (groupType: string) => {
    if (locationId) {
      addOddOrEvenGroup({ locationId: +locationId, groupType });
    }
  };

  const reloadTable = () => {
    if (locationId) {
      getGroups(+locationId);
    }
  };

  useEffect(() => {
    if (isSuccessAddOddOrEvenGroup) {
      toast.success(Strings.groups.createGroupSuccess);
      reloadTable();
    }
  }, [isSuccessAddOddOrEvenGroup]);

  useEffect(() => {
    reloadTable();
  }, []);

  const redirectToXSeriesSetup = () => {
    navigate(`/locations/${locationId}/applications/groups/xSeriesSetup`);
  };
  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between align-items-center">
            <div className="col-4 text-left">
              <StyledBackButtonNavigator
                size="small"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIos />
              </StyledBackButtonNavigator>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.groups.title}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              <Tooltip
                title={Strings.groups.addEvenGroup}
                placement="top"
                arrow
                componentsProps={TooltipStyled}
              >
                <ButtonIconStyled
                  size="small"
                  onClick={() => handleAddOddOrEvenGroup('EVEN')}
                >
                  <span>
                    <Add />
                    {Strings.groups.even}
                  </span>
                </ButtonIconStyled>
              </Tooltip>
              <Tooltip
                title={Strings.groups.addOddGroup}
                placement="top"
                arrow
                componentsProps={TooltipStyled}
              >
                <ButtonIconStyled
                  size="small"
                  onClick={() => handleAddOddOrEvenGroup('ODD')}
                >
                  <span>
                    <Add />
                    {Strings.groups.odd}
                  </span>
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      {isLoadingGroups ? (
        <LoadingRowsComponent />
      ) : (
        <GroupsListTemplate
          setOpenSideBar={setOpenSideBar}
          openRightSideBarForMethod={openRightSideBarForMethod}
          openSideBar={openSideBar}
          sideBarOpenFor={sideBarOpenFor}
          dataGroups={dataGroups || []}
          reloadTable={() => reloadTable()}
          redirectToXSeriesSetup={redirectToXSeriesSetup}
        />
      )}
    </>
  );
};
